import { createAction } from 'redux-actions';
import { change } from 'redux-form';
import { map } from 'lodash';
import { batchActions } from 'redux-batched-actions';
import {
  SERVICE_DETAIL_FETCH,
  SERVICE_DETAIL_SUCCESS,
  SERVICE_DETAIL_FAILURE
} from './actionTypes';
import api from '../../services/api';
import { SERVICE_FORM_NAME } from '../ServiceForm/constants';

//<<<---SERVICE-DETAIL--->>>
export const serviceDetailFetch = createAction(SERVICE_DETAIL_FETCH);
export const serviceDetailSuccess = createAction(SERVICE_DETAIL_SUCCESS);
export const serviceDetailFailure = createAction(SERVICE_DETAIL_FAILURE);

export const fetchServiceDetail = (id, lang) => async dispatch => {
  dispatch(serviceDetailFetch());
  try {
    const { data } = await api.get(`service/${id}/${lang}`);

    const { showOnHomepage, headerImageLarge } = data;

    const fieldNames = [
      'title',
      'description',
      'header',
      'headerImageSmall',
      'image',
      'slug',
      'subtitle',
      'content'
    ];

    const fieldChangeActions = map(fieldNames, fieldName =>
      change(SERVICE_FORM_NAME, fieldName, data[fieldName])
    );
    fieldChangeActions.push(
      change(SERVICE_FORM_NAME, 'headerImageLarge', {
        src: `https://api.alfadent.ikiguys.net${headerImageLarge}`
      })
    );

    fieldChangeActions.push(
      change(SERVICE_FORM_NAME, 'showOnHomepage', showOnHomepage && showOnHomepage === 'true')
    );

    dispatch(batchActions(fieldChangeActions));
    dispatch(serviceDetailSuccess());
  } catch (error) {
    dispatch(serviceDetailFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/ServiceDetail/actions.js